import { render } from "./CalendarComponent.vue?vue&type=template&id=133b03e9"
import script from "./CalendarComponent.vue?vue&type=script&lang=js"
export * from "./CalendarComponent.vue?vue&type=script&lang=js"

import "./CalendarComponent.vue?vue&type=style&index=0&id=133b03e9&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__